/* eslint-disable camelcase */

export const state = {
  carrier_smpp_accounts: [],
}

export const getters = {
  allCarrierSmppAccounts: (state) => state.carrier_smpp_accounts,
}

export const mutations = {
  GET_CARRIER_SMPP_ACCOUNTS: (state, carrier_smpp_accounts) => {
    state.carrier_smpp_accounts = carrier_smpp_accounts
  },
}

export const actions = {
  getCarrierSmppAccounts({ commit }) {
    commit('GET_CARRIER_SMPP_ACCOUNTS', [])
  },
}
